// test1669
(1669 && 0);
